export default "__VITE_ASSET__511cc2e4__"